import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../services/app.service';
import { ILang } from '../../model/lang.interface';

@Component({
    selector: 'processes-view-overlay',
    templateUrl: 'processes.overlay.page.html',
    styleUrls: ["../../app.component.scss", "processes.overlay.page.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ProcessesViewOverlayComponent {
    public ready: boolean = false;

    @Input() active: boolean;
    @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() currentLang: ILang;
    @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

    constructor(protected appService: AppService) {
        this.ready = true;
    }

    public close(): void {
        this.active = false;
        this.activeChange.emit(false);
    }
}
